import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CookieConsent from '../cookie/CookieConsent';
import styles from '../styles/account/Account.module.scss';

const ConsoSmallFooter = () => {
    const year = new Date();
    
    return (
        
        <div className={styles.footer}>
            <Container >
                <Row className="mx-auto">
                    <Col xs="12" className="copyright py-3 text-center">
                        <p className="">@Copyright {year.getFullYear()} Conso Media Group. Toate drepturile rezervate</p>
                    </Col>
                </Row>
            </Container>
            <CookieConsent />
        </div>
      
    );
}

export default ConsoSmallFooter;